import { BASE_ACTION_TYPE } from 'api/types';
import * as AddToJourneyNode from 'ui/actions/add-to-journey/traveller-node';
import * as AnonymizeTextNode from 'ui/actions/anonymize-text/traveller-node';
import * as AskAIAgentNode from 'ui/actions/ask-ai-agent/traveller-node';
import * as AskAINode from 'ui/actions/ask-ai/traveller-node';
import * as BranchNode from 'ui/actions/branch/traveller-node';
import * as BranchBaseNode from 'ui/actions/branch_base/traveller-node';
import * as BreakLoopNode from 'ui/actions/break-loop/traveller-node';
import * as CalendarEventNode from 'ui/actions/calendar-event/traveller-node';
import * as CodeNode from 'ui/actions/code/traveller-node';
import * as ComboSendFormNode from 'ui/actions/combo-send-form/traveller-node';
import * as ConditionNodeV2 from 'ui/actions/condition-v2/traveller-node';
import * as ConditionNode from 'ui/actions/condition/traveller-node';
import * as ConvertDocumentNode from 'ui/actions/convert-document/traveller-node';
import * as CreateDocumentNode from 'ui/actions/create-document/traveller-node';
import * as ExtractTextNode from 'ui/actions/extract-text/traveller-node';
import * as FormatterNode from 'ui/actions/formatter/traveller-node';
import * as GhostNode from 'ui/actions/ghost/traveller-node';
import * as IntegrationNode from 'ui/actions/integration/traveller-node';
import * as LoopNode from 'ui/actions/loop/traveller-node';
import * as MergeNode from 'ui/actions/merge/traveller-node';
import * as PlaceholderNode from 'ui/actions/placeholder/traveller-node';
import * as SendEmailNode from 'ui/actions/send-email/traveller-node';
import * as SendSmsNode from 'ui/actions/send-sms/traveller-node';
import * as StartNode from 'ui/actions/start/traveller-node';
import * as TriggersNode from 'ui/actions/triggers/traveller-node';
import * as UpdateFieldsNode from 'ui/actions/update-fields/traveller-node';
import * as UpdateTravellerNode from 'ui/actions/update-traveller/traveller-node';
import * as WaitForNode from 'ui/actions/wait-for/traveller-node';
import * as WaitUntilFixedNode from 'ui/actions/wait-until-fixed/traveller-node';
import * as WaitUntilRelativeNode from 'ui/actions/wait-until-relative/traveller-node';
import * as WebhookNode from 'ui/actions/webhook/traveller-node';

export const nodeTypes: Record<BASE_ACTION_TYPE, any> = {
  journey_start: StartNode,
  journey_triggers: TriggersNode,
  journey_branch: BranchNode,
  branch_base: BranchBaseNode,
  code: CodeNode,
  journey_merge: MergeNode,
  send_email: SendEmailNode,
  send_sms: SendSmsNode,
  combo_send_form: ComboSendFormNode,
  condition: ConditionNode,
  condition_v2: ConditionNodeV2,
  convert_document: ConvertDocumentNode,
  create_document: CreateDocumentNode,
  calendar_event: CalendarEventNode,
  wait_for_time: WaitForNode,
  wait_until_fixed_date: WaitUntilFixedNode,
  wait_until_relative_date: WaitUntilRelativeNode,
  integration: IntegrationNode,
  webhook: WebhookNode,
  placeholder: PlaceholderNode,
  break_loop: BreakLoopNode,
  journey_loop: LoopNode,
  ghost: GhostNode,
  formatter: FormatterNode,
  ask_ai: AskAINode,
  ask_ai_agent: AskAIAgentNode,
  update_fields: UpdateFieldsNode,
  add_to_journey: AddToJourneyNode,
  update_traveller: UpdateTravellerNode,
  hidden: GhostNode,
  anonymize_text: AnonymizeTextNode,
  extract_text: ExtractTextNode,
};
